import { Content } from "antd/lib/layout/layout";
import React, { useState } from "react";
import { BarChartOutlined, CalendarOutlined, AppstoreOutlined, ApartmentOutlined, NodeIndexOutlined } from "@ant-design/icons";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import TaskHeatmap from "../../components/reports/TaskHeatmap";
import IndividualTaskReport from "../../components/reports/IndividualTaskReport";
import DependenciesReport from "../../components/reports/DependenciesReport";
import WeeklyReflection from "../../components/reports/WeeklyReflection";
import MonthlyViewSplitPlans from "../../components/reports/MonthlyViewSplitPlans";
import DependenciesTab from "../../components/reports/DependenciesTab";
import DependencyOverview from "../../components/reports/DependencyOverview";
import { usePermissions } from "../../hooks/usePermissions";

function Reports() {
  const proHeight = document.body.clientHeight;
  const [activeTab, setActiveTab] = useState("charts");
  const [monthlyDrillDown, setMonthlyDrillDown] = useState(null); // { positionId, month (0-indexed), year }
  const { hasDependencyViewPermission, hasHeatmapPermission } = usePermissions();

  function handleHeatmapCellClick({ userId, positionIds, monthIdx, year }) {
    setMonthlyDrillDown({ userId, positionIds, monthIdx, year });
    setActiveTab("monthly-split");
  }

  const TABS = [
    { key: "charts", label: "Charts & Monthly Heatmaps", icon: <BarChartOutlined /> },
    { key: "monthly-split", label: "Monthly View", icon: <AppstoreOutlined /> },
    { key: "reflection", label: "Weekly Reflection", icon: <CalendarOutlined /> },
    ...(!hasDependencyViewPermission ? [{ key: "dependencies", label: "Dependencies", icon: <ApartmentOutlined /> }] : []),
    ...(hasDependencyViewPermission ? [{ key: "dep-overview", label: "Dependency Overview", icon: <NodeIndexOutlined /> }] : []),
  ];

  const left = (
    <>
      <div className="pri-font text-lg">Reports</div>
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {/* Custom Tab Bar */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              marginBottom: 28,
              padding: "6px 8px",
              backgroundColor: "#f8fafc",
              borderRadius: 10,
              border: "1px solid #e2e8f0",
              width: "fit-content",
            }}
          >
            {TABS.map((tab) => {
              const isActive = activeTab === tab.key;
              return (
                <div
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 7,
                    padding: "8px 18px",
                    borderRadius: 7,
                    cursor: "pointer",
                    fontSize: 13,
                    fontWeight: isActive ? 600 : 400,
                    color: isActive ? "#fff" : "#64748b",
                    backgroundColor: isActive ? "#0f172a" : "transparent",
                    transition: "all 0.2s ease",
                    whiteSpace: "nowrap",
                  }}
                  onMouseEnter={(e) => { if (!isActive) e.currentTarget.style.backgroundColor = "#f1f5f9"; }}
                  onMouseLeave={(e) => { if (!isActive) e.currentTarget.style.backgroundColor = "transparent"; }}
                >
                  <span style={{ fontSize: 14 }}>{tab.icon}</span>
                  {tab.label}
                </div>
              );
            })}
          </div>

          {/* Tab Content */}
          {activeTab === "charts" && (
            <div>
              {hasHeatmapPermission && <TaskHeatmap onCellClick={handleHeatmapCellClick} />}
              <div style={{ marginTop: 48, paddingTop: 32, borderTop: "2px solid #e2e8f0" }}>
                <IndividualTaskReport />
              </div>
              <div style={{ marginTop: 48, paddingTop: 32, borderTop: "2px solid #e2e8f0" }}>
                <DependenciesReport />
              </div>
            </div>
          )}
          {activeTab === "reflection" && <WeeklyReflection />}
          {activeTab === "monthly-split" && <MonthlyViewSplitPlans drillDown={monthlyDrillDown} onClearDrillDown={() => setMonthlyDrillDown(null)} />}
          {activeTab === "dependencies" && <DependenciesTab />}
          {activeTab === "dep-overview" && <DependencyOverview />}
        </div>
      </Content>
    </>
  );
}

export default Reports;
